import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import UploadFile from "@/components/UplaodFileVideo";
const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [appFileList, setAppFileList] = useState([]);
  const contractsRef = useRef();
  const { Option } = Select;
  useImperativeHandle(ref, () => ({
    openModal: (type, modalName) => {
      setVisible(true);
    },
  }));
  const addUpload = async (files, fieldType = "advertising") => {
    try {
      setLoading(true);
      const uploadedFiles = await uploadFiles(files, fieldType);
      setAppFileList((prev) => {
        const merged = [...prev, ...uploadedFiles];
        const unique = merged.filter(
          (item, index, arr) =>
            arr.findIndex((f) => f.path === item.path) === index
        );
        return unique;
      });
    } catch (error) {
      console.error("上传失败", error);
      message.error("File upload failed.");
    }
  };

  async function uploadFiles(data, fieldType) {
    const files = [];

    for (const item of data) {
      const formData = new FormData();
      formData.append("files", item.originFileObj);
      formData.append("type", fieldType);

      try {
        const response = await http.post(`${api.getAppAdUpload}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("upload", response);
        if (response.code === "1") {
          files.push(...response.data);
        }
      } catch (error) {
        console.error("上传出错:", error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
    return files;
  }

  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        title: values.title,
        content: values.content,
        url: values.url,
        type: values.type,
        sourceRemark: values.sourceRemark,
        appFileList: appFileList,
      };
      console.log(queryParams);
      const response = await http.post(
        `${api.getAppAdvertistAdd}`,
        queryParams
      );
      if (response.code === "1") {
        message.success("Add role successfully");
        setVisible(false);
        setAppFileList([]); //上传成功后清空
        form.resetFields();
        onSuccess?.();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error("Submit an error and try again later.");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            NEW Advertising
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={
 <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "20px",
              marginLeft: "20px",
            }}
          >
            Advertising Info
          </div>
          <div className="model_content">
            <Form
              {...layout}
              name="passwordResetForm"
              onFinish={onFinishAdd}
              form={form}
              labelCol={{
                style: {
                  width: "150px",
                },
              }}
              wrapperCol={{
                style: {
                  flex: 1,
                },
              }}
            >
              <Form.Item
                name="type"
                label="Advertising Type"
                rules={[
                  {
                    required: true,
                    message: "Please select Advertising Type.",
                  },
                ]}
              >
                <Select placeholder="Please select Advertising Type" allowClear>
                  <Option value="carousel">Carousel</Option>
                  <Option value="text">Text</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="title"
                label="Advertising Title"
                rules={[
                  { required: true, message: "Please enter title." },
                  { max: 50, message: "Title cannot exceed 50 characters." },
                ]}
              >
                <Input
                  placeholder="Please enter title."
                  allowClear
                  maxLength={50}
                  showCount
                />
              </Form.Item>

              <Form.Item
                name="content"
                label="Contents"
                rules={[
                  { required: true, message: "Please enter contents." },
                  {
                    max: 200,
                    message: "Contents cannot exceed 200 characters.",
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="Please enter contents."
                  allowClear
                  maxLength={200}
                  showCount
                  autoSize={{ minRows: 3, maxRows: 6 }}
                />
              </Form.Item>

              <Form.Item name="url" label="Url">
                <Input placeholder="Please enter url." allowClear />
              </Form.Item>

              <Form.Item name="sourceRemark" label="Source Remark">
                <Input placeholder="Please enter source  remark." allowClear />
              </Form.Item>

              {/* URL视频 上传 */}

              <Form.Item name="Picture or video" label="Picture or video">
                <UploadFile
                  //  onFileRemove={handleRemove}
                  ref={contractsRef}
                  sendDataToParent={(files) => addUpload(files)}
                  accept=".pdf,.jpg,.png,.mp4"
                  multiple
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
